//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import type { FpVisitTypeEnum } from './FpOutletVisit';

export type FpVisitAddressModelType = {
    latLng: {
        lat: number,
        lng: number
    },
    timeWindow: {
        slot: {
            start: string,
            end: string
        },
        transactionDuration: number
    },
    locationAddress: {
        placeName: ?string,
        localityName: ?string,
        formattedAddress: ?string,
        subLocalityName: ?string,
        pincode: ?string,
        city: ?string,
        state: ?string,
        countryCode: ?string,
        locationType: ?FpVisitTypeEnum,
        placeHash: ?string
    }
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpVisitAddress extends ImmutableModel {
    static fromJS(json: FpVisitAddressModelType): FpVisitAddress {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): FpVisitAddressModelType {
        return {
            latLng: this.latLng,
            timeWindow: this.timeWindow,
            locationAddress: this.locationAddress
        };
    }

    get latLng(): {
        lat: number,
        lng: number
    } {
        return this._state.get('latLng');
    }

    setLatLng(latLng: { lat: number, lng: number }): this {
        return this.clone(this._state.set('latLng', latLng));
    }

    get timeWindow(): {
        slot: {
            start: string,
            end: string
        },
        transactionDuration: number
    } {
        return this._state.get('timeWindow');
    }

    setTimeWindow(timeWindow: {
        slot: {
            start: string,
            end: string
        },
        transactionDuration: number
    }): this {
        return this.clone(this._state.set('timeWindow', timeWindow));
    }

    get locationAddress(): {
        placeName: ?string,
        localityName: ?string,
        formattedAddress: ?string,
        subLocalityName: ?string,
        pincode: ?string,
        city: ?string,
        state: ?string,
        countryCode: ?string,
        locationType: ?FpVisitTypeEnum,
        placeHash: ?string
    } {
        return this._state.get('locationAddress');
    }

    setLocationAddress(locationAddress: {
        placeName: ?string,
        localityName: ?string,
        formattedAddress: ?string,
        subLocalityName: ?string,
        pincode: ?string,
        city: ?string,
        state: ?string,
        countryCode: ?string,
        locationType: ?FpVisitTypeEnum,
        placeHash: ?string
    }): this {
        return this.clone(this._state.set('locationAddress', locationAddress));
    }
}
